module.exports = __webpack_public_path__ + "63e4c16c4a3a5468dfcab187a831960c.svg";